import { render, staticRenderFns } from "./SendedNotificationList.vue?vue&type=template&id=fe8413fe"
import script from "./SendedNotificationList.vue?vue&type=script&lang=js"
export * from "./SendedNotificationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports